<section class="py-3 layout-wrapper">
  <div class="container-fluid card d-flex flex-column h-100">
    <div class="flex-shrink-0">
      <div class="d-flex justify-content-between align-items-center flex-wrap mb-2">
        <h3 class="text strat pt-3">Export List</h3>
        <div class="d-flex align-items-center gap-2">
          <button class="btn fw-bold filter-toggle flex-grow-1 flex-md-grow-0" (click)="refreshList()"
            style="background-color: transparent; border: 1px solid #ced4da">
            <fa-icon class="me-1 text-dark" [icon]="faRotate" size="sm"></fa-icon>
            <span class="text-dark fw-bold small">Refresh</span>
          </button>
          <button class="btn btn-add-sale text-end m-1" (click)="goBack()">
            <fa-icon class="me-1" [icon]="faArrowLeft" size="sm"></fa-icon>
            Back
          </button>
        </div>
      </div>
    </div>

    <div class="flex-grow-1 mt-3" style="min-height: 0">
      <div class="table-responsive h-100" infiniteScroll [scrollWindow]="false" [infiniteScrollDistance]="2"
        [infiniteScrollThrottle]="500" (scrolled)="onScroll()">
        <table class="table custom-table align-middle m-0">
          <thead>
            <tr>
              <th>FILE NAME</th>
              <th>STATUS</th>
              <th>EXPORTED BY</th>
              <th>DATE</th>
              <th>ACTIONS</th>
            </tr>
          </thead>
          @if (data.length >= 1) {
          <tbody>
            @for (item of data; track item) {
            <tr class="normal-row">
              <td class="table-text-one">{{ item.filePath }}</td>
              <td class="table-text-one">{{ item.status }}</td>
              <td class="table-text-two">{{ item.createdBy.name }}</td>
              <td class="table-text-one">
                {{
                item.created
                | date: "dd-MM-yyyy hh:mm:ss a" : "Asia/Kolkata"
                }}
              </td>
              <td class="table-text-one">
                <button class="btn btn-sm btn-download" (click)="downloadSheet(item)" [disabled]="!item.sheetUrl"
                  [title]="
                        item.sheetUrl ? 'Download Sheet' : 'No sheet available'
                      ">
                  <fa-icon [icon]="faDownload" size="sm"></fa-icon>
                </button>
              </td>
            </tr>
            }
          </tbody>
          }
        </table>
        @if (loader) {
        <div>
          <div class="custom-col-width-100 d-flex justify-content-center">
            <app-loader [loadingIcon]="loader"></app-loader>
          </div>
        </div>
        }
        @if (!loader && data.length === 0) {
        <div>
          <div class="custom-col-width-100 text-danger d-flex justify-content-center">
            No Records Found!
          </div>
        </div>
        }
      </div>
    </div>
  </div>
</section>

@if (errorMessage) {
<app-toaster [title]="errorMessage" (closeToaster)="closeToster()"></app-toaster>
}